import { render, staticRenderFns } from "./UserExperienceTable.vue?vue&type=template&id=24694f0b&"
import script from "./UserExperienceTable.vue?vue&type=script&lang=js&"
export * from "./UserExperienceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports